import React, { FC } from 'react';
import { Button, Typography } from '@mui/material';

interface NoItemCardProps extends React.HTMLAttributes<HTMLDivElement> {
    title: string;
    subtitle: string;
    textBtn?: string;
    onClickBtn?: () => void;
    imageIcon?: React.ReactNode;
}

const NoItemCard: FC<NoItemCardProps> = ({
    title,
    subtitle,
    textBtn,
    onClickBtn,
    children,
    imageIcon = <div />,
    ...props
}) => {
    return (
        <div className={`flex flex-col pt-16 items-center text-center`} {...props}>
            <div className={`text-50`}>{imageIcon}</div>
            <Typography variant="h6" component="div">
                {title}
            </Typography>
            <p className={`text-primary-70`}>{subtitle}</p>

            <div className={`pt-20`}>
                {children ? (
                    children
                ) : (
                    <Button variant="outlined" color="primary" fullWidth onClick={onClickBtn} className={`mt-20`}>
                        <div className={`px-10`}>{textBtn}</div>
                    </Button>
                )}
            </div>
        </div>
    );
};

export default NoItemCard;
